import * as React from 'react';

import {
  ActionKind,
  ActionParamsButton,
  BaseClickable,
} from 'components/ui/BaseClickable';

import IconBadgeContent, {
  IconBadgeContentProps,
} from './IconBadgeContent/IconBadgeContent';

export type IconBadgeProps = IconBadgeContentProps & {
  onClick?: VoidFunction;
};

const IconBadge: React.FC<IconBadgeProps> = ({
  onClick,
  className,
  ...props
}: IconBadgeProps) => {
  const clickableAction = React.useMemo((): ActionParamsButton<any> => {
    return {
      actionKind: ActionKind.button,
      complexOnClick: {
        onClick: () => onClick?.(),
      },
    };
  }, [onClick]);

  if (!onClick) {
    return <IconBadgeContent {...props} className={className} />;
  }

  return (
    <BaseClickable
      withCursorPointer
      withHover
      action={clickableAction}
      className={className}
    >
      <IconBadgeContent {...props} />
    </BaseClickable>
  );
};

export default React.memo(IconBadge);
